export default __webpack_public_path__ + "static/media/binance-logo.b74aae29.svg";